const translation = {
  // Navigation
  nav_home: 'الرئيسية',
  nav_gallery: 'المعرض',
  nav_features: 'المميزات',
  nav_location: 'الموقع',
  nav_contact: 'اتصل بنا',

  // Hero Section
  hero_title: 'الفخامة المعاصرة في قلب شمال إيطاليا',
  hero_subtitle: 'إجمالي المساحة الداخلية: 505 متر مربع | المساحة التجارية: 667.31 متر مربع | المساحة الخارجية: 1,190 متر مربع | فئة الطاقة A3 | تقنية المنزل الذكي | حمام سباحة بالمياه المالحة المدفأ',
  hero_cta: 'حدد موعد للمشاهدة',
  hero_learn_more: 'اعرف المزيد',
  hero_property_info: 'إجمالي المساحة الداخلية: 505 متر مربع | المساحة التجارية: 667.31 متر مربع | المساحة الخارجية: 1,190 متر مربع | فئة الطاقة A3 | تقنية المنزل الذكي | حمام سباحة بالمياه المالحة المدفأ',

  // ... (חלקים אחרים של הקובץ נשארים ללא שינוי)

  // **Sports & Culture Section – duplicate keys removed / renamed**
  sports_culture_title: 'ثقافة رياضية غنية',
  sports_culture_desc: 'إلى جانب سباقات السيارات، تتمتع منطقة فاريزي بثقافة رياضية متنوّعة وغنية. تضم المدينة مرافق للرياضة المتعددة.',
  // kept first definitions of carousel items
  sports_culture_carousel_1: 'Pallacanestro Varese',
  sports_culture_carousel_2: 'Trevalli Varesina',
  sports_culture_carousel_3: 'Golf club Varese',
  sports_culture_carousel_4: 'Palaghiaccio Varese',
  // **Removed second set of duplicated carousel keys**

  // **Excursions Summary – duplicate keys removed**
  excursions_summary_title: 'خلاصة',
  excursions_summary_desc: 'تقدم فاريزي توازنًا متناغمًا بين الراحة والمتعة. يمكنك الاطمئنان بوجود مستشفيات وخدمات ممتازة على مقربة منك، ثم الخروج في نفس اليوم لمشاهدة فيلم أو حفل موسيقي، أو ركوب دراجة حول بحيرات خلابة، أو زيارة متحف فني في فيلا تاريخية، أو الاستمتاع ببيتزا إيطالية أصيلة وحلويات تقليدية.',
  // **Removed the later duplicated definition of the same keys**

  // ... (שאר הקובץ נשאר ללא שינוי)
};

export default translation;